import { render, staticRenderFns } from "./ILEBKids.vue?vue&type=template&id=c625c820&scoped=true"
import script from "./ILEBKids.vue?vue&type=script&lang=js"
export * from "./ILEBKids.vue?vue&type=script&lang=js"
import style0 from "./ILEBKids.vue?vue&type=style&index=0&id=c625c820&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c625c820",
  null
  
)

export default component.exports